import Head from 'next/head';
import { GetStaticPaths, GetStaticProps } from 'next';

// Components
import Form from '@components/pages/cpa/epnbz/apply/Form';
import BaseSanitizer from '@base/BaseSanitizer';

// Helpers
import useI18n, { getLocalePaths } from '@i18n';

// HOCs
import WithRole, { rolesEnum } from '@HOCs/WithRole';

// Styles
import styles from '@pages/cpa/epnbz/apply/application.module.scss';
import { companyName } from '@config/globalDomain';

const Application: React.FC = () => {
    const { t } = useI18n('Cpa');

    return (
        <>
            <Head>
                <title>{t('Leave a request to connect an offer to ePN', { companyName })}</title>
                <meta
                    name="description"
                    content={t(
                        'Make a step to a guaranteed increase in sales due to high-quality traffic',
                    )}
                />
            </Head>
            <main className={styles.wrapper}>
                <div className={styles.title}>
                    <BaseSanitizer
                        html={t('Order application for an offer - advertiser')}
                        tag="h1"
                    />
                </div>
                <Form />
            </main>
        </>
    );
};

export default WithRole(Application, [rolesEnum.guest]);

export const getStaticProps: GetStaticProps = async ({ params }) => {
    return { props: { locale: params?.locale } };
};

export const getStaticPaths: GetStaticPaths = async () => {
    return { paths: getLocalePaths(), fallback: false };
};
